const searchToggle = document.querySelector('.glassmorphism-button--search');
const searchBar = document.querySelector('.header__search-bar');
const searchClose = document.querySelector('.header__search-close');
const searchInput = document.querySelector('.header__search-input');
const searchResults = document.querySelector('.custom-search-results');
const searchResultsContent = document.querySelector('.search-results-content');

let isSearchOpen = false;
let searchTimeout;

function performSearch(query) {
  if (query.length < 2) {
    hideSearchResults();
    return;
  }

  showLoading();

  // AJOUT : On demande explicitement à Shopify de chercher dans le titre, le type, le vendeur, le SKU et l'EAN (barcode)
  const searchUrl = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,vendor,variants.sku,variants.barcode`;

  fetch(searchUrl)
    .then(response => response.json())
    .then(data => {
      const products = data.resources.results.products || [];
      displaySearchResults(products, query);
    })
    .catch(error => {
      console.error('Erreur de recherche:', error);
      showError();
    });
}

function showLoading() {
  searchResultsContent.innerHTML = '<div class="search-loading">Recherche en cours...</div>';
  searchResults.classList.add('show');
}

function showError() {
  searchResultsContent.innerHTML = '<div class="search-no-results">Une erreur est survenue lors de la recherche</div>';
  searchResults.classList.add('show');
}

function displaySearchResults(products, query) {
  if (!products || products.length === 0) {
    searchResultsContent.innerHTML = `
      <div class="search-no-results">
        <div>Aucun produit trouvé pour "${query}"</div>
      </div>
    `;
  } else {
    let html = `
      <div class="search-results-header">
        <h3 class="search-results-title">Produits trouvés</h3>
        <p class="search-results-count">${products.length} résultat${products.length > 1 ? 's' : ''}</p>
      </div>
      <div class="search-results-grid">
    `;

    products.forEach(product => {
      const imageUrl = product.image ? product.image : '';
      const price = product.price + ' €';

      html += `
        <a href="${product.url}" class="search-product-item">
          ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" class="search-product-image" loading="lazy">` : ''}
          <div class="search-product-info">
            <h4 class="search-product-title">${product.title}</h4>
            ${price ? `<p class="search-product-price">${price}</p>` : ''}
          </div>
        </a>
      `;
    });

    html += '</div>';

    if (products.length > 0) {
      html += `
        <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&type=product" class="search-view-all">
          Voir tous les résultats
        </a>
      `;
    }

    searchResultsContent.innerHTML = html;
  }
  searchResults.classList.add('show');
}

function hideSearchResults() {
  searchResults.classList.remove('show');
  setTimeout(() => {
    searchResultsContent.innerHTML = '';
  }, 400);
}

function openSearch() {
  if (searchBar && !isSearchOpen) {
    isSearchOpen = true;
    searchBar.classList.add('opening');
    searchBar.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
      searchBar.classList.remove('opening');
    }, 100);
  }
}

function closeSearch() {
  if (searchBar && isSearchOpen) {
    isSearchOpen = false;
    searchBar.classList.add('closing');
    hideSearchResults();

    setTimeout(() => {
      searchBar.style.display = 'none';
      searchBar.classList.remove('closing');
      document.body.style.overflow = '';
      if (searchInput) {
        searchInput.value = '';
      }
    }, 300);
  }
}

if (searchInput) {
  searchInput.addEventListener('input', function() {
    const query = this.value.trim();
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  searchInput.addEventListener('focus', function() {
    const query = this.value.trim();
    if (query.length >= 2) {
      performSearch(query);
    }
  });
}

if (searchToggle) searchToggle.addEventListener('click', openSearch);
if (searchClose) searchClose.addEventListener('click', closeSearch);

document.addEventListener('click', function(e) {
  if (!searchBar.contains(e.target)) {
    hideSearchResults();
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeSearch();
  }
});